import React, { Suspense } from 'react';

import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';
import LazyLoadable from '@helpers/LazyLoadable';
import { lazy } from '@loadable/component';

const DPRCard = LazyLoadable(lazy(() => import('./DPR/DprCard')));

export const ROUTES_DPR = [
  {
    path: "/dpr",
    element: <Suspense fallback={<LoadingSpinner />}> <DPRCard /></Suspense>,
  },

];
